import React, { useState } from 'react';
import styles from './Dashboard.module.css';
import FeaturesCard from './FeaturesCard';
import dipsIcon from '../../assets/image/dashboard-images/Vector.png'
import trendsIcon from '../../assets/image/dashboard-images/graph 1.png'
import stocksIcon from '../../assets/image/dashboard-images/global-economy.png'
import etfIcon from '../../assets/image/dashboard-images/pie-chart 1.png'
import { FaCircleChevronUp } from "react-icons/fa6";
import Insights from './Insights';
import { Watchlist } from '../watchlist/Watchlist';
import { useHistory, } from 'react-router-dom';
import Header from '../../components/header/Header';
import HomeBreadcrumbs from '../../components/breadcrumbs/HomeBreadcrumbs';

export const Dashboard = (props) => {

  const history = useHistory();
  const [showSidebar, setShowSidebar] = useState(false);

  const feature_tiles = [
    {
      id: 0,
      icon: dipsIcon,
      title: "Dips",
      sharename: "Dow Jones",
      desc: "Spot undervalued stocks by identifying price drops in the market."
    },
    {
      id: 1,
      icon: trendsIcon,
      title: "Trends",
      sharename: "Axis Cap",
      desc: "Track upward and downward market movements to anticipate momentum and make smarter investments."
    },
    {
      id: 2,
      icon: stocksIcon,
      title: "Stocks 360",
      lock: true,
      sharename: "BSE",
      desc: "Get a comprehensive overview of individual stocks with real-time data, charts, and performance metrics."
    },
    {
      id: 3,
      icon: etfIcon,
      title: "Past Performance",
      lock: true,
      sharename: "Dow Jones",
      desc: "Analyze historical performance of stocks and indices to identify long-term patterns and returns."
    },
    {
      id: 4,
      icon: dipsIcon,
      title: "Feedback",
      lock: true,
      sharename: "Dow Jones",
      desc: "Share your feedback and access detailed usage reports to improve your experience with the platform."
    },
    {
      id: 5,
      icon: trendsIcon,
      title: "Breakouts",
      lock: true,
      sharename: "Axis Cap",
      desc: "Detect technical breakouts that signal potential high-momentum trades and trend reversals."
    },
    {
      id: 6,
      icon: stocksIcon,
      title: "Patterns",
      lock: true,
      sharename: "BSE",
      desc: "Identify common trading patterns like head and shoulders, flags, and wedges in stock charts."
    },
    {
      id: 7,
      icon: etfIcon,
      title: "Customer Support",
      lock: true,
      sharename: "Dow Jones",
      desc: "Reach out to our support team for assistance with features, subscriptions, or technical issues."
    }
  ];

  const goToIndividualFeature = (index) => {
    switch (index) {
      case 0: history.push('/home/dip'); break;
      case 1: history.push('/home/trend'); break;
      default: break;
    }
  };

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <div className='container-fluid'>
      <div className={styles.dashboard_content_section}>
  
        <Header toggleSidebar={toggleSidebar} showSidebar={showSidebar} />
  
        <div className='container-fluid'>
          <div className={styles.dashboard_main_wrapper}>
            <div className={styles.breadcrumbs_section}>
              <HomeBreadcrumbs />
            </div>
            <div className={`${styles.wrapper}`}>
              <div className={styles.dashboard_title}>
                <h4>Features</h4>
                <span><FaCircleChevronUp /></span>
              </div>
  
  
              <div className='feature-tile-wrapper col-12'>
                <div className='row'>
                  {/* {
                      feature_tiles.map((tile, index) => {
                        return (
                          <div className="col-md-3" key={index}>
                            <div className={`card ${styles.card}`} onClick={() => props.navigationCallback(index)}>
                              <img alt='feature-symbol' src={require('../../assets/image/investment.png')} className={`card-img-left ${styles.iconImage}`} />
                              <div className="card-body" >
                                <h5 className="card-title">{tile.title}</h5>
                                <p className="card-text">{tile.desc}</p>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    } */}
                  {
                    feature_tiles.map((tile, index) => (
                      <div
                        className='col-lg-3 col-md-6 col-sm-12'
                        key={index}
                        onClick={() => {
                          if (!tile.lock) {
                            goToIndividualFeature(index)
                          }
                        }}
                      >
                        <FeaturesCard
                          icon={tile.icon}
                          featureHeading={tile.title}
                          shareName={tile.sharename}
                          cardDesc={tile.desc}
                          lock={tile.lock}
                        />
                      </div>
                    ))
                  }
  
                </div>
              </div>
  
              <Insights />
            </div>
  
            <div className={`${styles.dashboard_watchlist_section}`}>
                <Watchlist />
              </div>
          </div>
        </div>
  
      </div>
    </div>
  )
}
